import React from 'react';
import Icon from '../../../components/AppIcon';

const MessageThread = ({ messages, isTyping }) => {
  const formatTimestamp = (date) => {
    return new Date(date)?.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'sent':
        return <Icon name="Check" size={14} color="currentColor" />;
      case 'delivered':
        return (
          <div className="flex -space-x-1">
            <Icon name="Check" size={14} color="currentColor" />
            <Icon name="Check" size={14} color="currentColor" />
          </div>
        );
      case 'read':
        return (
          <div className="flex -space-x-1 text-[#5B2DFF]">
            <Icon name="Check" size={14} color="currentColor" />
            <Icon name="Check" size={14} color="currentColor" />
          </div>
        );
      default:
        return null;
    }
  };

  const renderAttachment = (attachment) => {
    if (attachment?.type === 'image') {
      return (
        <div className="mt-2 rounded-lg overflow-hidden max-w-xs">
          <img src={attachment?.url} alt={attachment?.name} className="w-full h-auto" />
        </div>
      );
    }

    return (
      <div className="mt-2 flex items-center gap-2 p-3 bg-white/10 rounded-lg max-w-xs">
        <Icon name="FileText" size={20} />
        <div className="flex-1 min-w-0">
          <p className="text-sm font-medium truncate">{attachment?.name}</p>
          <p className="text-xs opacity-70">{attachment?.size}</p>
        </div>
        <button className="p-1 hover:bg-white/10 rounded">
          <Icon name="Download" size={16} />
        </button>
      </div>
    );
  };

  return (
    <div className="space-y-4">
      {messages?.map((message, index) => {
        const isCandidate = message?.sender === 'candidate';
        const showTimestamp = index === 0 || 
          (new Date(message?.timestamp) - new Date(messages?.[index - 1]?.timestamp)) > 3600000;

        return (
          <div key={message?.id}>
            {showTimestamp && (
              <div className="flex justify-center mb-4">
                <span className="text-xs text-[#6B7280] bg-[#F6F7FB] px-3 py-1 rounded-full">
                  {formatTimestamp(message?.timestamp)}
                </span>
              </div>
            )}

            <div className={`flex ${isCandidate ? 'justify-end' : 'justify-start'}`}>
              <div className={`max-w-[75%] md:max-w-[60%]`}>
                <div
                  className={`rounded-2xl p-3 md:p-4 ${
                    isCandidate
                      ? 'bg-[#5B2DFF] text-white'
                      : 'bg-[#F6F7FB] text-[#111827]'
                  }`}
                >
                  <p className="text-sm md:text-base whitespace-pre-wrap break-words">
                    {message?.content}
                  </p>

                  {message?.attachments?.map((attachment, idx) => (
                    <div key={idx}>{renderAttachment(attachment)}</div>
                  ))}
                </div>

                <div className={`flex items-center gap-1 mt-1 px-2 ${
                  isCandidate ? 'justify-end' : 'justify-start'
                }`}>
                  <span className="text-xs text-[#6B7280]">
                    {new Date(message?.timestamp)?.toLocaleTimeString('en-US', {
                      hour: 'numeric',
                      minute: '2-digit',
                      hour12: true
                    })}
                  </span>
                  {isCandidate && message?.status && (
                    <span className="text-[#6B7280]">
                      {getStatusIcon(message?.status)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        );
      })}

      {/* Typing Indicator */}
      {isTyping && (
        <div className="flex justify-start">
          <div className="bg-[#F6F7FB] rounded-2xl p-4 max-w-[75%]">
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 bg-[#6B7280] rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
              <div className="w-2 h-2 bg-[#6B7280] rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
              <div className="w-2 h-2 bg-[#6B7280] rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageThread;